import { configureStore } from "@reduxjs/toolkit";

// Host Slices
import { alertSlice, allOrdersCompletedSlice, allOrdersPendingSlice, allOrdersPickedSlice, allOrdersRequestedSlice, allOrdersPaymentCompletedSlice, allOrdersSlice, orderDetailsSlice, recentOrdersSlice, signupSlice } from "./slices/adminSlices";
import { loginSlice } from "./slices/adminSlices";
import { sideNavSlice } from "./slices/adminSlices";
import { allHostsSlice, hostDeleteSlice, hostDetailSlice, hostEarningsSlice, hostPendingEarningsSlice, hostPropertiesSlice } from "./slices/HostSlices";
import { allDriversSlice, driverDeleteSlice, driverDetailSlice, driverEarningsSlice, driverOrdersSlice, driverPendingEarningsSlice } from "./slices/driverSlices";
import { propertyDeleteSlice, propertyDetailsSlice, propertyUpdateSlice } from "./slices/propertySlices";
import { packagesSlice, updatePackageSlice } from "./slices/packageSlices";
import { productsSlice } from "./slices/krogerSlices";
import leadsReducer from './slices/leadsSlice';
import templatesReducer from './slices/templatesSlice';
import inquiriesReducer from './slices/inquiriesSlice';
import orderTrackingReducer from "./slices/orderTrackingSlices";

// Do NOT preload adminInfo or token from localStorage — auth is decided only after /auth/me succeeds.
const initialState = {
  login: { 
    adminInfo: null,
    token: null 
  }
};

export const store = configureStore({
  reducer: {
    login: loginSlice.reducer,
    signUp: signupSlice.reducer,

    // orders
    allOrders: allOrdersSlice.reducer,
    recentOrders: recentOrdersSlice.reducer,
    allOrdersCompleted: allOrdersCompletedSlice.reducer,
    allOrdersPending: allOrdersPendingSlice.reducer,
    allOrdersRequested: allOrdersRequestedSlice.reducer,
    allOrdersPaymentCompleted: allOrdersPaymentCompletedSlice.reducer,
    allOrdersPicked: allOrdersPickedSlice.reducer,
    orderDetails: orderDetailsSlice.reducer,

    //packages
    packages: packagesSlice.reducer,
    updatePackageStatus: updatePackageSlice.reducer,

    // host
    allHosts: allHostsSlice.reducer,
    hostDetails: hostDetailSlice.reducer,
    hostProperties: hostPropertiesSlice.reducer,
    deleteHost: hostDeleteSlice.reducer,
    hostEarnings: hostEarningsSlice.reducer,
    hostPendingEarnings: hostPendingEarningsSlice.reducer,

    //property
    propertyUpdate: propertyUpdateSlice.reducer,
    propertyDetails: propertyDetailsSlice.reducer,
    propertyDelete: propertyDeleteSlice.reducer,

    // drivers
    allDrivers: allDriversSlice.reducer,
    driverDetails: driverDetailSlice.reducer,
    driverOrders: driverOrdersSlice.reducer,
    driverDelete: driverDeleteSlice.reducer,
    driverEarnings: driverEarningsSlice.reducer,
    driverPendingEarnings: driverPendingEarningsSlice.reducer,

    // Kroger
    products: productsSlice.reducer,

    // sideNav
    sideNav: sideNavSlice.reducer,
    alert: alertSlice.reducer,

    //leads and templates
    leads: leadsReducer,
    templates: templatesReducer,

    //inquiries
    inquiries: inquiriesReducer,

    //tracking order live
    orderTracking: orderTrackingReducer,
  },
  preloadedState: initialState,
});
